import 'Plugins/counterUpPlugin';

export default function initCounterUp() {
	jQuery('.counter').counterUp({
		delay: 10,
		time: 2000
	});
}